import angular from 'angular';

import { attachmentThumbnailDirective } from './attachments/attachment-thumbnail.directive';
import { codemirrorAndToolbarDirective } from './codemirror-and-toolbar.directive.js';
import { editor2ContextMenuDirective } from './context-menu/context-menu.directive';
import { editor2Directive } from './editor2.directive';

angular
  .module('editor2', [])
  .directive('editor2', editor2Directive)
  .directive('codemirrorAndToolbar', codemirrorAndToolbarDirective)
  .directive('attachmentThumbnail', attachmentThumbnailDirective)
  .directive('editor2ContextMenu', editor2ContextMenuDirective)
  ;
